import App from 'app/app.js';

function PackageBundleService(ProductCatalogStore, OrderLineFactory, JobStore) {
  const getPackage = (skuCode, jobKey) => {
    const packages = jobKey
      ? JobStore.getJobData(jobKey)?.productCatalog?.packages
      : ProductCatalogStore.getProductCatalog().packages;
    return structuredClone(packages?.find((p) => p.skuCode === skuCode));
  };

  this.getOptIns = function (subject) {
    if (!!subject) {
      return {
        retouching: !subject.optOutOfRetouchingEnhancements,
        personalization: !subject.optOutOfPersonalizationEnhancements
      };
    }
    return { retouching: true, personalization: true };
  };

  const jobHasBundles = (pkg, jobKey) => {
    const packages = jobKey
      ? JobStore.getJobData(jobKey)?.productCatalog?.packages
      : ProductCatalogStore.getProductCatalog().packages;
    return pkg.bundlePackages.every((bundlePkg) => !!packages?.find((p) => p.skuCode === bundlePkg.skuCode));
  };

  this.partialEnhancements = (skuCode, jobKey) => {
    this.noNoGo = false;
    this.noRetouching = false;

    const pkg = getPackage(skuCode, jobKey);
    if (pkg?.upgrades?.length === 1) {
      if (pkg.upgrades[0].type.includes('RETOUCHING')) {
        this.noNoGo = true;
      } else if (pkg.upgrades[0].type === 'PERSONALIZATION') {
        this.noRetouching = true;
      }
    }
    if (pkg?.bundlePackages) {
      return pkg.bundlePackages.some(
        (bundlePkg) => bundlePkg.hasRetouching === true || bundlePkg.hasPersonalization === true
      );
    }
  };

  this.isBasePackage = (skuCode, jobKey) => {
    const pkg = getPackage(skuCode, jobKey);
    return (
      !!pkg && pkg.isBasePackage && !!pkg.bundlePackages && pkg.bundlePackages.length > 0 && jobHasBundles(pkg, jobKey)
    );
  };

  this.isBundlePackage = (skuCode, jobKey) => {
    const pkg = getPackage(skuCode, jobKey);
    return !!pkg && pkg.isBundlePackage;
  };

  this.getBundlePackage = (skuCode, subject, newOptIns, jobKey) => {
    const pkg = getPackage(skuCode, jobKey);
    let flag;
    if (pkg) {
      flag = this.partialEnhancements(pkg.skuCode, jobKey);
    }
    const optIns = newOptIns || this.getOptIns(subject);

    if (
      (optIns.retouching && optIns.personalization) ||
      (!flag && optIns.personalization && !this.noNoGo) ||
      (!flag && optIns.retouching && !this.noRetouching)
    ) {
      return pkg;
    }

    let bundlePackage;

    if (pkg?.bundlePackages) {
      if (pkg.bundlePackages.length === 1) {
        bundlePackage = pkg.bundlePackages[0];
      } else {
        bundlePackage = pkg.bundlePackages.find(
          (bundle) => bundle.hasRetouching === optIns.retouching && bundle.hasPersonalization === optIns.personalization
        );
      }
    }

    if (bundlePackage) {
      return getPackage(bundlePackage.skuCode, jobKey);
    }
  };

  this.getBasePackage = (skuCode, jobKey) => {
    const packages = jobKey
      ? JobStore.getJobData(jobKey)?.productCatalog?.packages
      : ProductCatalogStore.getProductCatalog().packages;
    return packages
      ?.filter((pkg) => pkg.isBasePackage === true)
      .find((pkg) => (pkg.bundlePackages || []).find((bundle) => bundle.skuCode === skuCode));
  };

  /**
   * @param orderLine
   * @param subject
   * @param newOptIns - optional, will fallback on the subject's optIns
   * @returns new OrderLine
   */
  this.swapPackage = (orderLine, subject, newOptIns, jobKey) => {
    const sku = orderLine.orderable.isBundlePackage ? orderLine.orderable.basePackage : orderLine.orderable.skuCode;
    const pkg = this.getBundlePackage(sku, subject, newOptIns, jobKey);
    const newOrderLine = OrderLineFactory.createFromPackage(pkg, jobKey);

    const swappedItems = [];
    newOrderLine.orderLineDetails.forEach((orderLineDetail) => {
      const previousOrderLineDetail = orderLine.orderLineDetails.find(
        (oldDetail) => oldDetail.item.skuCode === orderLineDetail.item.skuCode && !swappedItems.includes(oldDetail)
      );

      if (previousOrderLineDetail) {
        swappedItems.push(previousOrderLineDetail);
        orderLineDetail.look = previousOrderLineDetail.look;
        orderLineDetail.item.parsedSheets = previousOrderLineDetail.item.parsedSheets;
        orderLineDetail.item.isEditMode = previousOrderLineDetail.item.isEditMode;
        orderLineDetail.item.isItemViewable = previousOrderLineDetail.item.isItemViewable;
        orderLineDetail.item.isItemViewableButNotCutomizable =
          previousOrderLineDetail.item.isItemViewableButNotCutomizable;
        orderLineDetail.item.viewed = previousOrderLineDetail.item.viewed;
      }
    });

    return newOrderLine;
  };

  this.updatePackageOptIns = function (newOptIns, subject) {
    if (!!subject) {
      subject.optOutOfRetouchingEnhancements = !newOptIns.retouching;
      subject.optOutOfPersonalizationEnhancements = !newOptIns.personalization;
    }
  };
}

App.service('PackageBundleService', ['ProductCatalogStore', 'OrderLineFactory', 'JobStore', PackageBundleService]);
